import { TAX_YEAR_2021 } from '@common-packages/shared-constants';

import { defaultColumnDefinitionWithFilter } from '../shared/columnDefinitions';
import { IconCellRendererFactory } from '../shared/columnDefinitions/cellRenderers';
import {
  getCheckBoxGroupNameColumnDefinition,
  getCheckBoxGroupDescriptionColumnDefinition,
  getCheckBoxGroupValueColumnDefinition,
} from '../shared/columnDefinitions/checkBoxGroup.columnDefinition';

const getColumnDefinitions = ({
  rowData,
  getRowData,
  checkboxGroups,
  isInEditMode,
  updateGroup,
  updateRow,
  filingTypeId,
  taxYear,
  permissionForBankData,
}) => [
  { ...getCheckBoxGroupNameColumnDefinition({ checkboxGroups }) },
  { ...getCheckBoxGroupDescriptionColumnDefinition({ checkboxGroups }) },
  (() => {
    const {
      cellEditorSelector: checkboxGroupValueCellEditorSelector,
      ...checkboxGroupValueColumnBase
    } = getCheckBoxGroupValueColumnDefinition({
      ...(getRowData ? { getRowData } : { rowData }),
      isInEditMode,
      updateGroup,
      updateRow,
      filingTypeId,
    });

    return {
      ...checkboxGroupValueColumnBase,
      editable: params => {
        const aliasName = params.data.aliasName;
        if (
          isInEditMode &&
          (aliasName.toUpperCase() === 'ACCOUNTNUMBER' ||
            aliasName.toUpperCase() === 'ROUTINGNUMBER')
        ) {
          return permissionForBankData;
        }
        return isInEditMode;
      },
      // Do not set cellEditor: agTextCellEditor here — it overrides cellEditorSelector and forces
      // rich-select paths to misbehave. Bank fields use agTextCellEditor only via selector below.
      cellEditorSelector: params => {
        const aliasName = params.data?.aliasName;
        const upper = aliasName?.toUpperCase?.();
        const isBank = upper === 'ACCOUNTNUMBER' || upper === 'ROUTINGNUMBER';
        if (isInEditMode && isBank && permissionForBankData) {
          if (
            (aliasName === 'ACCOUNTNUMBER' || aliasName === 'ROUTINGNUMBER') &&
            taxYear > TAX_YEAR_2021
          ) {
            const tooltipMessageCustom =
              upper === 'ACCOUNTNUMBER'
                ? 'Bank Account Number - 17 alphanumeric characters with hyphens'
                : 'Routing Transit Number - 9 digits beginning with 01 through 12, or 21 through 32';
            return {
              component: 'agTextCellEditor',
              params: {
                tooltipMessageCustom,
                useFormatter: true,
              },
            };
          }
          return {
            component: 'agTextCellEditor',
            params: {
              useFormatter: true,
              inputProps: {},
            },
          };
        }
        return checkboxGroupValueCellEditorSelector(params);
      },
      valueFormatter: params => {
        const shouldMaskBankData = params.data.shouldMaskBankData;
        const value = params.value;
        if (shouldMaskBankData) {
          if (isInEditMode) {
            if (value === 'XXXXX') {
              if (!params.data.originalValue) {
                params.data.originalValue = value;
              }
              params.data.value = '';
            }
          } else {
            params.data.value = params.data.originalValue || 'XXXXX';
          }
        }
        return value;
      },
      cellStyle: params => {
        const shouldMaskBankData = params.data.shouldMaskBankData;
        if (shouldMaskBankData) {
          return { color: 'gray' };
        }
        return null;
      },
    };
  })(),
  ...(taxYear < TAX_YEAR_2021
    ? [
        {
          ...defaultColumnDefinitionWithFilter,
          headerName: 'State Override',
          field: 'isTripletGlobal',
          width: 100,
          cellRenderer: IconCellRendererFactory({
            getName: (value, data) =>
              !data.isTripletGlobal && data.isAccountGlobal ? 'check-mark' : '',
          }),
          cellStyle: {
            textAlign: 'center',
          },
        },
        {
          ...defaultColumnDefinitionWithFilter,
          headerName: 'Is Global Account',
          field: 'isAccountGlobal',
          width: 100,
          cellRenderer: IconCellRendererFactory({
            getName: isAccountGlobal => (isAccountGlobal ? 'check-mark' : ''),
          }),
          cellStyle: {
            textAlign: 'center',
          },
        },
      ]
    : []),
];

export default getColumnDefinitions;
